import AdminLayout from '@/layouts/AdminLayout.vue'

// Admin routes with lazy loading - ensure base URL is used for chunk loading
const AdminRoutes = [
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import(/* webpackChunkName: "admin-dashboard" */ /* webpackMode: "eager" */ '@/views/admin/Dashboard.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: () => import(/* webpackChunkName: "admin-users" */ /* webpackMode: "eager" */ '@/views/admin/UserManagement.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'content',
        name: 'ContentManagement',
        component: () => import(/* webpackChunkName: "admin-content" */ /* webpackMode: "eager" */ '@/views/admin/ContentManagement.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'settings',
        name: 'SystemSettings',
        component: () => import(/* webpackChunkName: "admin-settings" */ /* webpackMode: "eager" */ '@/views/admin/Settings.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      }
    ]
  }
]

export default AdminRoutes
